export enum FavoritesFeedListType {
  all = 'all',
  news = 'news',
  posts = 'community_posts',
}
